import CommunicationPage from "./communication/index.js";
import SettingEnergyPage from "./energy/index.js";
import SettingPage from "./index.js";
import SettingReportTreePage from "./report/tree.js";

export default {
  path: "setting",
  children: [
    {
      path: "",
      element: <SettingPage />,
    },
    {
      path: "dashboard",
      element: <SettingPage />,
    },
    {
      path: "communication",
      element: <CommunicationPage />,
    },
    {
      path: "energy",
      element: <SettingEnergyPage />,
    },
    {
      path: "report/tree",
      element: <SettingReportTreePage />,
    },
  ],
};
